/**
 * NatureTokenTray — active player's nature-token count + pinned row.
 *
 * Originally derived from the (removed) board-game-playground for visual parity. UI is NOT shared (CLAUDE.md).
 */

export interface NatureTokenTrayProps {
  readonly count: number;
  readonly spentThisTurn: number;
  readonly estimatedScore: number | null;
}

export function NatureTokenTray({
  count,
  spentThisTurn,
  estimatedScore,
}: NatureTokenTrayProps) {
  return (
    <div
      data-testid="cascadia-nature-tray"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 16px",
        background: "var(--cn-cascadia-tile-bg)",
        borderTop: "1px solid var(--cn-cascadia-market-slot-border)",
        minHeight: 44,
        gap: 12,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <span
          style={{
            fontSize: 12,
            color: "var(--cn-cascadia-nature)",
            fontWeight: 600,
          }}
        >
          Nature:
        </span>
        <span
          data-testid="cascadia-nature-count"
          style={{
            fontSize: 14,
            color: "var(--cn-cascadia-nature)",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          {Array.from({ length: count }, (_, i) => (
            <span
              key={i}
              aria-hidden="true"
              style={{ color: "var(--cn-cascadia-nature)" }}
            >
              ●
            </span>
          ))}
          {count === 0 ? <span>0</span> : null}
          {spentThisTurn > 0 ? (
            <span
              style={{
                fontSize: 11,
                color: "var(--cn-cascadia-label)",
                marginLeft: 4,
              }}
            >
              (-{spentThisTurn})
            </span>
          ) : null}
        </span>
      </div>

      {estimatedScore !== null ? (
        <div
          data-testid="cascadia-score-estimate"
          style={{
            fontSize: 12,
            color: "var(--cn-cascadia-label)",
          }}
        >
          Score est: {estimatedScore}
        </div>
      ) : null}
    </div>
  );
}
